module.exports = __webpack_public_path__ + "img/05_ic_drill_black_62px.2913ff60.svg";